export default function ({ store, redirect, route, app, error }) {
	let scUser = app.$cookies.get("savings-center-info")

	if(scUser && scUser["childrenCount"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "childrenCount", value: scUser["childrenCount"]})
	}
	if(scUser && scUser["children"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: scUser["children"]})
	}
	if(scUser && scUser["email"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: scUser["email"]})
	}
	if(scUser && scUser["next_step_v3"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: scUser["next_step_v3"]})
	}
	if(scUser && scUser["state"]){
		let copyState = {}
		Object.assign(copyState, scUser["state"])
		store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: copyState})
	}
	if(scUser && scUser["youngerAge"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "youngerAge", value: scUser["youngerAge"]})
	}
	if(scUser && scUser["olderAge"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "olderAge", value: scUser["olderAge"]})
	}
	if(scUser && scUser["householdInconme"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "householdInconme", value: scUser["householdInconme"]})
	}
	if(scUser && scUser["type_of_user"]){
		store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: scUser["type_of_user"]})
	}

	// // There is no savings center cookie and user tried to get into the savigns enter
	if(!app.$cookies.get("savings-center-info") && route.fullPath.indexOf("/savings-center/") != -1){
		return redirect('/?savings-center=true')
	}else{
		if (scUser) {
			store.dispatch('trackLogin', scUser)
		}
	}
}